function clamp(value, min, max) {
  return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}
export {
  clamp as default
};
//# sourceMappingURL=clamp.js.map
